import React, { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

  .ag-scene {
    min-height: 100vh; display: flex; align-items: center; justify-content: center;
    background: #09090b; position: relative; overflow: hidden; font-family: 'Syne', sans-serif;
  }
  .ag-grid {
    position: absolute; inset: 0;
    background-image: linear-gradient(rgba(255,255,255,.03) 1px, transparent 1px),
                      linear-gradient(90deg, rgba(255,255,255,.03) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black 40%, transparent 100%);
  }
  .ag-glow {
    position: absolute; width: 600px; height: 600px; border-radius: 50%; pointer-events: none;
    background: radial-gradient(ellipse, rgba(99,102,241,.12) 0%, transparent 70%);
    left: 50%; top: 50%; transform: translate(-50%, -50%);
  }
  .ag-card {
    position: relative; width: 380px; background: rgba(255,255,255,.03);
    border: 1px solid rgba(255,255,255,.08); border-radius: 20px; padding: 40px;
    backdrop-filter: blur(20px); animation: ag-fadeUp .5s ease both; z-index: 1;
  }
  .ag-card::before {
    content: ''; position: absolute; inset: 0; border-radius: 20px; pointer-events: none;
    background: linear-gradient(135deg, rgba(99,102,241,.08) 0%, transparent 50%);
  }
  @keyframes ag-fadeUp { from { opacity: 0; transform: translateY(16px) } to { opacity: 1; transform: translateY(0) } }
  @keyframes ag-shake  { 0%,100% { transform: translateX(0) } 25% { transform: translateX(-6px) } 75% { transform: translateX(6px) } }
  @keyframes ag-pulse  { 0%,100% { opacity: 1 } 50% { opacity: .4 } }
  .ag-logo { width: 40px; height: 40px; background: linear-gradient(135deg,#6366f1,#8b5cf6); border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-bottom: 28px; font-size: 18px; }
  .ag-title { font-size: 22px; font-weight: 700; color: #f4f4f5; margin-bottom: 4px; letter-spacing: -.02em; }
  .ag-sub { font-size: 13px; color: #71717a; margin-bottom: 32px; font-family: 'JetBrains Mono', monospace; }
  .ag-label { display: block; font-size: 11px; font-weight: 600; color: #a1a1aa; text-transform: uppercase; letter-spacing: .08em; margin-bottom: 8px; font-family: 'JetBrains Mono', monospace; }
  .ag-input { width: 100%; background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.08); border-radius: 10px; padding: 12px 16px; font-size: 14px; color: #f4f4f5; font-family: 'Syne', sans-serif; outline: none; transition: border-color .2s, background .2s; }
  .ag-input::placeholder { color: #3f3f46; }
  .ag-input:focus { border-color: rgba(99,102,241,.6); background: rgba(99,102,241,.05); }
  .ag-hint { font-size: 11px; color: #52525b; margin-top: 6px; font-family: 'JetBrains Mono', monospace; }
  .ag-btn { width: 100%; margin-top: 8px; padding: 13px; background: linear-gradient(135deg,#6366f1,#8b5cf6); border: none; border-radius: 10px; color: #fff; font-size: 14px; font-weight: 600; font-family: 'Syne', sans-serif; cursor: pointer; letter-spacing: .01em; transition: opacity .15s, transform .1s; }
  .ag-btn:hover { opacity: .9; }
  .ag-btn:active { transform: scale(.98); }
  .ag-err { background: rgba(239,68,68,.08); border: 1px solid rgba(239,68,68,.2); border-radius: 8px; padding: 10px 14px; font-size: 12px; color: #f87171; margin-bottom: 16px; font-family: 'JetBrains Mono', monospace; animation: ag-shake .3s ease; }
  .ag-divider { display: flex; align-items: center; gap: 12px; margin: 20px 0; }
  .ag-divider span { font-size: 11px; color: #3f3f46; font-family: 'JetBrains Mono', monospace; white-space: nowrap; }
  .ag-divider::before, .ag-divider::after { content: ''; flex: 1; height: 1px; background: rgba(255,255,255,.06); }
  .ag-footer { text-align: center; font-size: 11px; color: #52525b; font-family: 'JetBrains Mono', monospace; }
  .ag-badge { display: inline-flex; align-items: center; gap: 5px; font-size: 10px; font-family: 'JetBrains Mono', monospace; color: #71717a; background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.07); border-radius: 20px; padding: 3px 10px; margin-bottom: 20px; }
  .ag-dot { width: 6px; height: 6px; background: #22c55e; border-radius: 50%; animation: ag-pulse 2s ease infinite; }
`;

export default function AuthGate({ children }) {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [ok, setOk]   = useState(false);
  const [err, setErr] = useState(false);
  const [errKey, setErrKey] = useState(0);

  const login = () => {
    if (user === "admin" && pass === "1234") {
      setErr(false);
      setOk(true);
    } else {
      setErr(true);
      setErrKey(k => k + 1); // re-trigger shake animation
    }
  };

  if (ok) return children;

  return (
    <>
      <style>{styles}</style>
      <div className="ag-scene">
        <div className="ag-grid" />
        <div className="ag-glow"  />
        <div className="ag-card">
          <div className="ag-logo">🔐</div>
          <div className="ag-title">Welcome back</div>

          {err && (
            <div key={errKey} className="ag-err">
              Invalid credentials. Try again.
            </div>
          )}

          <div style={{ marginBottom: 16 }}>
            <label className="ag-label">Username</label>
            <input className="ag-input" placeholder="username" value={user}
              onChange={e => setUser(e.target.value)}
              onKeyDown={e => e.key === "Enter" && document.getElementById("ag-pass")?.focus()}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label className="ag-label">Password</label>
            <input id="ag-pass" className="ag-input" type="password" placeholder="password" value={pass}
              onChange={e => setPass(e.target.value)}
              onKeyDown={e => e.key === "Enter" && login()}
            />
          </div>

          <button className="ag-btn" onClick={login}>Log in →</button>
        </div>
      </div>
    </>
  );
}